import React, {useEffect, useState} from 'react';
import ReactModal from "react-modal";
import Select from "react-select";

import {StandardButton} from "../../common/button/standard-button/StandardButton";
import {createPerson, retrieveAllPersons} from "../../../services/PersonService";
import {LeftLabelTextInput} from "../../common/input/left-label-text-input/LeftLabelTextInput";
import {createTrainingGroup, deleteTrainingGroup, updateTrainingGroup} from "../../../services/TrainingService";
import {ConfirmDeleteModal} from "../../common/confirmation-modal/ConfimDeleteModal";
import {sortPersonList} from "../../../util/PersonUtil";

export const TrainingGroupCapture = ({context, setSpinnerText, showToaster, navigateTo, navigateBack}) => {

    ReactModal.setAppElement('#root');

    const [allPersonList, setAllPersonList] = useState([]);
    const [showPersonModal, setShowPersonModal] = useState(false);
    const [selectedPersonList, setSelectedPersonList] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [organisation, setOrganisation] = useState("");
    const [role, setRole] = useState("");
    const [email, setEmail] = useState("");
    const [trainingModuleList, setTrainingModuleList] = useState([]);
    const [nameOfGroup, setNameOfGroup] = useState("");
    const [extRefToBeDeleted, setExtRefToBeDeleted] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchPersons();
    }, []);

    const fetchPersons = async () => {
        const [data] = await retrieveAllPersons(context.username);
        if (data) {
            if (data.responseStatus === "Success") {
                sortPersonList(data.personVOList);
                const mappedPersons = data.personVOList.map((person) => {
                    return {value: person.externalReference, label: person.firstName + " " + person.lastName}
                });
                setAllPersonList(mappedPersons);
            }
        }
    };

    useEffect(() => {
        if (context.newGroupTrainingSelected) {
            setSelectedPersonList([]);
            setNameOfGroup("");
        } else {
            if (context.selectedGroupTraining) {
                setNameOfGroup(context.selectedGroupTraining.name);
                const mappedSelectedPersons = context.selectedGroupTraining.groupMembers.map((person) => {
                    return {value: person.externalReference, label: person.firstName + " " + person.lastName}
                });
                setSelectedPersonList(mappedSelectedPersons);
            }
        }
    }, [context]);

    const handleCreatePersonClick = async () => {
        setSpinnerText("Creating Person");
        const personToBeSaved = {firstName, lastName, email, organisation, organisationRole: role, active: true};
        const [data, error] = await createPerson(context.username, personToBeSaved);
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                const savedPerson = data.savedPersonVO;
                setSelectedPersonList((prevState) => ([
                    ...prevState,
                    {value: savedPerson.externalReference, label: savedPerson.firstName + " " + savedPerson.lastName}
                ]));
                await closePersonModal();
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    const handleCreateOrUpdateGroupClick = async () => {
        setSpinnerText("Saving Group");

        const personExternalReferenceList = selectedPersonList.map((person) => {
            return person.value;
        });

        if (context.newGroupTrainingSelected) {

            const trainingGroup = {
                name: nameOfGroup,
                groupMembers: personExternalReferenceList.map((personExternalReference) => {
                    return {externalReference: personExternalReference}
                }),
            }

            const [data, error] = await createTrainingGroup(context.username, trainingGroup);
            if (data) {
                if (data.responseStatus === "Success") {
                    await resetScreen();
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }

            setSpinnerText(null);
            navigateTo("trainingGroupSearch");

        } else {

            const trainingGroup = {
                name: nameOfGroup,
                groupMembers: personExternalReferenceList.map((personExternalReference) => {
                    return {externalReference: personExternalReference}
                }),
                externalReference: context.selectedGroupTraining.externalReference,
            }

            const [data, error] = await updateTrainingGroup(context.username, trainingGroup);
            if (data) {
                if (data.responseStatus === "Success") {
                    await resetScreen();
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }

            setSpinnerText(null);
            navigateTo("trainingGroupSearch");
        }
    }

    const resetScreen = async () => {
        const [data] = await retrieveAllPersons(context.username);
        if (data) {
            if (data.responseStatus === "Success") {
                const mappedPersons = data.personVOList.map((person) => {
                    return {...person, displayValue: person.firstName + " " + person.lastName}
                });
                setAllPersonList(mappedPersons);
            }
        }
        setSelectedPersonList([]);
        const copyOfTrainingModuleList = JSON.parse(JSON.stringify(trainingModuleList));
        const mappedTrainingModuleList = copyOfTrainingModuleList.map((trainingModule) => {
            return {...trainingModule, isSelected: false};
        })
        setTrainingModuleList([...mappedTrainingModuleList]);
    }

    const handleDeleteGroupClick = async () => {
        setSpinnerText("Deleting Training");
        let trainingGroupDeleted = false;
        const [data, error] = await deleteTrainingGroup(context.username, context.selectedGroupTraining.externalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                trainingGroupDeleted = true;
            }
            showToaster(data);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        if (trainingGroupDeleted) {
            navigateTo("trainingGroupSearch");
        }
        setSpinnerText(null);
    }

    const closePersonModal = async () => {
        setShowPersonModal(false);
        setFirstName(null);
        setLastName(null);
        setEmail(null);
        setOrganisation(null);
        setRole(null);
        await fetchPersons();
    }

    const handleDeleteModalShow = async (extRef) => {
        setShowModal(true);
        setExtRefToBeDeleted(extRef);
    }

    return (
        <div className="training-capture-container">
            <div className="training-input-container">
                <div className="input-container">
                    <label>Name of Group:</label>
                    <input className="text-input"
                           type="text"
                           value={nameOfGroup}
                           onChange={({target}) => {
                               setNameOfGroup(target.value)
                           }}/>
                </div>
                <div className="input-container">
                    <label>Members:</label>
                    <Select options={allPersonList}
                            isMulti
                            closeMenuOnSelect={false}
                            onChange={(selectedPersons) => {
                                setSelectedPersonList(selectedPersons)
                            }}
                            value={selectedPersonList}
                            isDisabled={!allPersonList}
                            classNamePrefix="training-select"/>
                </div>
            </div>
            <div className="training-capture-person-container">
                <StandardButton text="New Person" onClick={() => {
                    setShowPersonModal(true)
                }}/>
            </div>
            <div className="training-capture-create-button-container">
                {!context.newGroupTrainingSelected && <StandardButton text="Back" onClick={navigateBack}/>}
                {!context.newGroupTrainingSelected && <StandardButton text="Delete Group"
                                                                      onClick={handleDeleteModalShow}/>}
                <StandardButton text={!context.newGroupTrainingSelected ? "Save Group" : "Create Group"}
                                onClick={handleCreateOrUpdateGroupClick}/>
            </div>

            <ReactModal isOpen={showPersonModal} className="modal-content" overlayClassName="modal-overlay">
                <p className="modal-title">Create Person</p>
                <LeftLabelTextInput labelText="First Name:"
                                    handleChange={({target}) => {
                                        setFirstName(target.value)
                                    }}/>
                <LeftLabelTextInput labelText="Last Name:"
                                    handleChange={({target}) => {
                                        setLastName(target.value)
                                    }}/>
                <LeftLabelTextInput labelText="Email:"
                                    handleChange={({target}) => {
                                        setEmail(target.value)
                                    }}/>
                <LeftLabelTextInput labelText="Organisation:"
                                    handleChange={({target}) => {
                                        setOrganisation(target.value)
                                    }}/>
                <LeftLabelTextInput labelText="Organisation Role:"
                                    handleChange={({target}) => {
                                        setRole(target.value)
                                    }}/>
                <div className="modal-button-container">
                    <StandardButton text="Create Person"
                                    onClick={handleCreatePersonClick}
                                    disabled={!firstName || !lastName || !organisation || !role}/>
                    <StandardButton text="Cancel"
                                    onClick={closePersonModal}/>
                </div>
            </ReactModal>
            {showModal &&
            <ConfirmDeleteModal showModal={showModal}
                                setShowModal={setShowModal}
                                titleToDelete={nameOfGroup}
                                onDeleteClick={() => {
                                    handleDeleteGroupClick(extRefToBeDeleted)
                                }}/>}
        </div>
    );
}
